import { render, staticRenderFns } from "./CardLavorazione.vue?vue&type=template&id=5f01c12a"
import script from "./CardLavorazione.vue?vue&type=script&lang=ts"
export * from "./CardLavorazione.vue?vue&type=script&lang=ts"
import style0 from "./CardLavorazione.vue?vue&type=style&index=0&id=5f01c12a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f01c12a')) {
      api.createRecord('5f01c12a', component.options)
    } else {
      api.reload('5f01c12a', component.options)
    }
    module.hot.accept("./CardLavorazione.vue?vue&type=template&id=5f01c12a", function () {
      api.rerender('5f01c12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardLavorazione.vue"
export default component.exports